module.exports = __webpack_public_path__ + "img/zapopan-norte.a72d87ab.jpg";